import { render, staticRenderFns } from "./PersonInOut.vue?vue&type=template&id=63251a1d&scoped=true"
import script from "./PersonInOut.vue?vue&type=script&lang=js"
export * from "./PersonInOut.vue?vue&type=script&lang=js"
import style0 from "./PersonInOut.vue?vue&type=style&index=0&id=63251a1d&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63251a1d",
  null
  
)

export default component.exports